// Stub for removed template hook — keeps template layout code working

export function useBuyNowLink() {
  return {
    buyNowLink: '#',
    isPhoenix: false,
    getQueryParams: ''
  };
}
